import { useEffect, useContext, useRef } from "react";
import { Context } from "./Reducers/Store";
import { Routes, Route, useLocation, Navigate, useNavigate } from "react-router-dom";

import Login from "./pages/Login/Login";
import EventoPublico from "./pages/EventoPublico/EventoPublico.js";
import ListaConfirmacoes from "./pages/Confirmacoes/ListaConfirmacoes.js";
import Dashboard from "./pages/Dashboard/Dashboard.js";
import EventoList from "./pages/Eventos/EventoList.js";
import EventoForm from "./pages/Eventos/EventoForm.js";
import ConvidadosEvento from "./pages/Convidados/ConvidadosEvento.js";

import LayoutEmpty from "./pages/Layouts/LayoutEmpty.js";
import SmartRedirect from "./components/SmartRedirect/index.js";
import RequireAuth from "./RequireAuth.js";
import LayoutDashboard from "./pages/Layouts/LayoutDashboard.js";
import AlterarSenha from "./pages/AlterarSenha/AlterarSenha.js";
import LayoutsManager from "./pages/Layouts/LayoutsManager.js";
import AceitarConviteAdmin from "./pages/AceitarConviteAdmin/AceitarConviteAdmin.js";
import UsuariosAdmin from "./pages/Usuarios/UsuariosAdmin.js";
import { buildAdminUrl, getEventExternalUrlFromHostname, isAdminHostname } from "./utils/publicEventUrl.js";

function RootRoute() {
	const eventExternalUrl = getEventExternalUrlFromHostname();
	return eventExternalUrl ? <EventoPublico /> : <SmartRedirect />;
}

function AdminHostRoute({ children }) {
	const location = useLocation();

	if (!isAdminHostname()) {
		const path = `${location.pathname}${location.search}${location.hash}`;
		window.location.replace(buildAdminUrl(path));
		return null;
	}

	return children;
}

export default function App() {
	const firstLoad = useRef(true);
	const navigate = useNavigate();
	const location = useLocation();
	const [state, dispatch] = useContext(Context);

	useEffect(() => {
		const jwt = localStorage.getItem("jwt");
		if (jwt)
			dispatch([
				{ type: "SET_LOGGED", payload: { token: jwt } },
				{ type: "SET_READY", payload: true }
			]);
		else
			dispatch([
				{ type: "SET_LOGGED", payload: null },
				{ type: "SET_READY", payload: true }
			]);
	}, [dispatch]);

	useEffect(() => {
		if (state.isLogged) {
			if (firstLoad.current) {
				firstLoad.current = false;
				if (location?.pathname === "/login") {
					navigate("/", { state: { from: { pathname: "/dashboard" } } });
				}
			}
		}
	}, [location?.pathname, navigate, state.isLogged]);

	return state.ready ?
		<Routes>
			<Route element={<LayoutEmpty />}>
				<Route path="/" element={<RootRoute />} />
				<Route path="/login" element={<AdminHostRoute><Login /></AdminHostRoute>} />
				<Route path="/aceitar-convite/:token" element={<AdminHostRoute><AceitarConviteAdmin /></AdminHostRoute>} />
				<Route path="/e/:slug" element={<EventoPublico />} />
				<Route path="/:codigoConfirmacao" element={<EventoPublico />} />
				<Route path="/confirmacoes/evento/:id" element={<AdminHostRoute><RequireAuth><ListaConfirmacoes /></RequireAuth></AdminHostRoute>} />
			</Route>

			<Route element={<AdminHostRoute><RequireAuth><LayoutDashboard /></RequireAuth></AdminHostRoute>}>
				<Route path="/dashboard" element={<Dashboard />} />
				<Route path="/eventos" element={<EventoList />} />
				<Route path="/eventos/novo" element={<EventoForm />} />
				<Route path="/eventos/:id" element={<EventoForm />} />
				<Route path="/eventos/:id/convidados" element={<ConvidadosEvento />} />
				<Route path="/layouts" element={<LayoutsManager />} />
				<Route path="/usuarios" element={<UsuariosAdmin />} />
				<Route path="/alterar-senha" element={<AlterarSenha />} />
			</Route>

			<Route path="*" element={<Navigate to="/login" />} />
		</Routes> : null;
}
